/**
 * メタフィールド／line item の販売時期から「予約販売」等の接頭辞を除く（重複表示防止）
 */
(function () {
  function getPrefixList() {
    var list = []
    if (window.variantStrings && window.variantStrings.preorderSalePrefix) {
      var p = String(window.variantStrings.preorderSalePrefix).trim()
      if (p) list.push(p)
    }
    list.push('予約販売', 'Pre-Order')
    return list
  }

  function normalizePreorderPeriod(raw) {
    var p = String(raw == null ? '' : raw).trim()
    if (!p) return ''

    var prefixes = getPrefixList()
    var changed = true
    while (changed && p) {
      changed = false
      for (var i = 0; i < prefixes.length; i++) {
        var pre = prefixes[i]
        if (!pre) continue
        if (p.indexOf(pre) === 0) {
          p = p.slice(pre.length).trim()
          if (p.charAt(0) === '　') p = p.slice(1).trim()
          changed = true
          break
        }
        var preSpace = pre + ' '
        if (p.indexOf(preSpace) === 0) {
          p = p.slice(preSpace.length).trim()
          if (p.charAt(0) === '　') p = p.slice(1).trim()
          changed = true
          break
        }
      }
    }
    return p
  }

  function formatPreorderCartLabel(period) {
    var normalized = normalizePreorderPeriod(period)
    if (!normalized) return ''
    var prefix =
      window.variantStrings && window.variantStrings.preorderSalePrefix
        ? String(window.variantStrings.preorderSalePrefix).trim()
        : ''
    var lang = document.body && document.body.getAttribute('data-lang')
    if (!prefix) prefix = lang === 'en' ? 'Pre-Order' : '予約販売'
    return prefix + ' ' + normalized
  }

  window.normalizePreorderPeriod = normalizePreorderPeriod
  window.formatPreorderCartLabel = formatPreorderCartLabel
})()
